import {fromJson} from '../core/data-source/json.mapper';
import {DataSource} from '../core/data-source/data-source';
import {httpService} from '../core/services/http.service';

export class GeocodingDataSource<T> extends DataSource<T> {
    protected apiPath: string = '/gt/gt-api/geocodings';

    async reverseGeocoding(lat: number, lon: number): Promise<T[]> {
        let queryString: string = '?lat=' + encodeURIComponent(lat + '') + '&lon=' + encodeURIComponent(lon + '');
        return httpService.get(this.apiPath + '/doReverseGeocoding' + queryString).then((response: any) => {
            return response.data.rows.map((v: any) => fromJson(this.recordClass, v));
        });
    }

    async reverseW3wGeocoding(lat: number, lon: number): Promise<string> {
        let queryString: string = '?lat=' + encodeURIComponent(lat + '') + '&lon=' + encodeURIComponent(lon + '');
        return httpService.get(this.apiPath + '/doReverseW3wGeocoding' + queryString).then((response: any) => {
            return response.data?.rows[0];
        });
    }

    async geocoding(query: string): Promise<T[]> {
        let queryString: string =
            '?query=' +
            encodeURIComponent(query || '') +
            '&types=simpleLandmarks' +
            '&types=geocoding' +
            '&calculateNearestPoint=false' +
            '&results=10' +
            '&strictSearch=true';
        return httpService.get(this.apiPath + queryString).then((response: any) => {
            return response.data.rows.map((v: any) => fromJson(this.recordClass, v));
        });
    }
}
